import React from "react";
import { Box, Typography, Chip } from "@mui/material";

const T = {
  navy: "#0a1628",
  blue: "#1a5aff",
  blueSoft: "#e8efff",
  border: "#e4e8f0",
  surface: "#f7f8fb",
  muted: "#8898b0",
  success: "#00c896",
};

const getFinalPrice = (variant) => {
  return variant?.finalPrice || variant?.salePrice || 0;
};

const VariantSelector = ({ variants, selectedVariant, onVariantSelect }) => {
  if (!variants || variants.length === 0) return null;
  const bestPrice = Math.min(...variants.map((v) => getFinalPrice(v)));
  const bestSaving = Math.max(
    ...variants.map((v) =>
      v.variantMrp
        ? ((v.variantMrp - getFinalPrice(v)) / v.variantMrp) * 100
        : 0,
    ),
  );

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      ></Box>
      <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
        {variants.map((variant) => {
          const price = getFinalPrice(variant);
          const savings = variant.variantMrp
            ? ((variant.variantMrp - price) / variant.variantMrp) * 100
            : 0;
          const isBestPrice = price === bestPrice;

          return (
            <Box
              key={variant.uuid}
              onClick={() => onVariantSelect(variant)}
              sx={{
                position: "relative",
                px: 2.5,
                py: 1,
                borderRadius: 3,
                border: `2px solid ${selectedVariant?.uuid === variant.uuid ? T.blue : T.border}`,
                bgcolor:
                  selectedVariant?.uuid === variant.uuid ? T.blueSoft : T.white,
                cursor: "pointer",
                transition: "all 0.2s ease",
                "&:hover": {
                  borderColor: T.blue,
                  bgcolor: T.blueSoft,
                  transform: "translateY(-2px)",
                  boxShadow: "0 4px 12px rgba(26,90,255,0.12)",
                },
              }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  fontWeight: 700,
                  color:
                    selectedVariant?.uuid === variant.uuid ? T.blue : T.navy,
                  textAlign: "center",
                }}
              >
                {variant.variantName}
              </Typography>
              <Typography
                sx={{
                  fontSize: 16,
                  fontWeight: 800,
                  color: T.blue,
                  textAlign: "center",
                  // mt: 0.5
                }}
              >
                ₹{price ? price.toFixed(2) : "0.00"}
              </Typography>
              {savings > 0 && (
                <Typography
                  sx={{
                    fontSize: 10,
                    color: T.success,
                    textAlign: "center",
                    fontWeight: 600,
                  }}
                >
                  Save {Math.round(savings)}%
                </Typography>
              )}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default VariantSelector;
